import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomButton from 'components/CustomInput/Button';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import UploadWrapper from 'components/UploadWrapper';
import { produce } from 'utility/general';
import UploadDisplay from 'components/uploadFile/UploadDisplay';

const SContent = styled.div`
    min-width: 400px;
    font-weight: 500;
`;

const CustomDialog = ({
    children,
    onConfirm = () => null,
    onCancel,
    isShow = false,
    title = '',
    description = '',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    loading = false,
    disableCancelButton = false,
    showUploadButton = false,
    width = 400,
    maxWidth = 'sm',
}) => {
    const [isFileUploading, setFileUploading] = useState(false);

    const [uploadFileNames, setUploadFileNames] = useState([]);

    const onFileUploaded = (list) => {
        setUploadFileNames([...uploadFileNames, ...list]);
        setFileUploading(false);
    };

    const onFileRemove = (index) => {
        setUploadFileNames(
            produce((draft) => {
                draft.splice(index, 1);
            }),
        );
    };

    return (
        <Dialog open={isShow} style={{ margin: 'auto' }} maxWidth={maxWidth}>
            <DialogTitle style={{ fontWeight: 'bold', position: 'relative', minWidth: width }}>
                <div style={{ fontSize: 16 }}>{title}</div>
                <div style={{ position: 'absolute', top: 5, right: 10 }}>
                    {onCancel && (
                        <IconButton onClick={onCancel}>
                            <CloseIcon />
                        </IconButton>
                    )}
                </div>
            </DialogTitle>
            <DialogContent>
                {description && (
                    <SContent>
                        <DialogContentText>{description}</DialogContentText>
                    </SContent>
                )}
                {children}

                <div style={{ marginTop: 30 }}>
                    <UploadDisplay
                        fileList={uploadFileNames.map((item) => ({ name: item.fileName }))}
                        enableRemove
                        onRemove={onFileRemove}
                    />
                </div>

                <div>
                    {showUploadButton && (
                        <UploadWrapper
                            optional
                            inputStyle
                            onFileUploadFinish={onFileUploaded}
                            onUploadFailed={() => setFileUploading(false)}
                            onLoadingChange={(isLoading) => {
                                setFileUploading(isLoading);
                            }}
                            multiple
                        />
                    )}
                </div>
            </DialogContent>
            <DialogActions style={{ padding: 12, paddingTop: 0, display: 'flex', justifyContent: 'flex-end' }}>
                <div>
                    {!disableCancelButton && (
                        <CustomButton style={{ marginRight: 10 }} type={'cancel'} onClick={onCancel && onCancel}>
                            {cancelText ?? 'Cancel'}
                        </CustomButton>
                    )}

                    <CustomButton
                        loading={loading || isFileUploading}
                        onClick={() => onConfirm({ files: uploadFileNames })}
                        autoFocus
                    >
                        {confirmText ?? 'Confirm'}
                    </CustomButton>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default CustomDialog;
